/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 15/03/2018.
*
* layouts-create-view Vue Component
*/
<template>
  <form-modal
    :hide-secondary-button="true"
    primary-button-label="Clonar y crear"
    modal-title="Clonar layout"
    @closeModal="onCloseModal"
    @primaryButtonClick="onSave"
  >
    <div class="content">
      <p>Al clonar un layout, se clonará el formato de la evaluación y creará un nuevo layout.</p>
      <layouts-form
        ref="form"
        :old="oldLayout"
      />
    </div>
  </form-modal>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import FormModal from '@/components/_shared/form-modal'
import LayoutsForm from '@/modules/layouts/layouts-form'
import LayoutsGuards from '@/guards/layouts.guards'

export default {
  name: 'LayoutsCreateView',
  components: {FormModal, LayoutsForm},
  computed: {
    oldLayout () {
      let clone = Object.assign({}, this.$store.getters['layouts/item'])
      clone.id = null
      return clone
    }
  },
  methods: {
    onCloseModal () {
      this.$router.push({name: 'layouts'})
    },
    onSave () {
      this.$refs.form.onSubmit()
    }
  },
  beforeRouteEnter: LayoutsGuards.onEdit
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style
  lang="scss"
  scoped
>
  .content {
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/layouts/layouts-clone-view.vue